var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tri",
      class: { selected: _vm.selected, disabled: _vm.disabled },
      on: { click: _vm.onClick }
    },
    [
      _c("van-icon", {
        staticClass: "tri-icon",
        attrs: { name: _vm.selected ? _vm.selectedIcon : _vm.unselectedIcon }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tri-label" },
        [
          _vm._t("default", function() {
            return [_vm._v(_vm._s(_vm.label))]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cc0d442", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc0d442","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/ToggleRadioItem.vue
// module id = 640
// module chunks = 75